import * as Inovx from '@shared';
import TaxonomyServices from '../services/TaxonomyServices';
import FacilityStore from '../stores/FacilityStore';
import TaxonomyConstants from './../constants/TaxonomyConstants';
var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;

var TaxonomyActions = {

    async getAllTaxonomy() {
        const data = await TaxonomyServices.getAll();
        TaxonomyActions._dispatchAction(TaxonomyConstants.TAXONOMY_SET_DATA, data)
        return data;
    },
    async getTaxonomyDetail(Id: string) {
        const data = await TaxonomyServices.getTaxonomyDetail(Id);
        return TaxonomyActions.receiveTaxonomyDetail(data);
    },
    receiveTaxonomyDetail(data: ILibraryTaxonomyDetail) {
        TaxonomyActions._dispatchAction(TaxonomyConstants.TAXONOMY_CLASIFICATION_DATA, data)
        return data;
    },
    async getVisibleTaxonomyDetail(Id: string) {
        const data = await TaxonomyServices.getVisibleTaxonomyDetail(Id);
        TaxonomyActions._dispatchAction(TaxonomyConstants.TAXONOMY_VISIBLE_CLASIFICATION_DATA, data)
        return data;
    },
    async getDeleteValidation(Id: string) {
        return TaxonomyServices.getDeleteValidation(Id);
    },
    async getClassificationTagDeleteValidation(taxonomyId: string, classificationTagId: string) {
        return TaxonomyServices.getClassificationTagDeleteValidation(taxonomyId, classificationTagId);
    },
    async updateTaxonomyDetail(data: ILibraryTaxonomyDetail) {
        TaxonomyActions._dispatchAction(TaxonomyConstants.TAXONOMY_CLASIFICATION_UPDATE_DATA, data)
        return data;
    },
    async cancelEdit(type: TaxonomyType): Promise<void> {
        if (FacilityStore.getHasTaxonomyChanges()) {
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: async () => {
                    await this.updateClassificationTag(type);
                },
                cancelCallback: async () => {
                    this._finishEdit(false);
                    await this._resetTaxonomyData(type);
                }
            });
        } else {
            this._finishEdit(false);
            await this._resetTaxonomyData(type);
        }
    },
    verifyTaxonomyChanges(): boolean {
        if (FacilityStore.getTaxonomyModalVisible()) {
            if (FacilityStore.getHasTaxonomyChanges()) {
                SystemActions.displayInfoMessage({
                    message: InovxLoader.t('facility:message.savePendingChangesInfo')
                });
                return false;
            }
        }
        return true;
    },
    verifyAndCloseTaxonomyEdit(): boolean {
        var verified = true;
        if (FacilityStore.getTaxonomyModalVisible()) {
            verified = this.verifyTaxonomyChanges();
            if (verified) {
                this._finishEdit(true);
            }
        }
        return verified;
    },
    async _resetTaxonomyData(type: TaxonomyType) {
        const data = FacilityStore.getTaxonomyClassificationDetail(type);
        if (data) {
            this.getTaxonomyDetail(data.ID);
        }
    },
    async createTaxonomy(name: string, type: TaxonomyType = TaxonomyType.KB, preRefreshCallback?: (newTaxonomy: ILibraryTaxonomyDetail) => void) {
        if (!SystemStore.isActionInProgress(TaxonomyConstants.TAXONOMY_UPDATE_EDIT)) {
            SystemActions.beginAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            try {
                const newTaxonomy = await TaxonomyServices.create({ Name: name, Type: type });

                if (preRefreshCallback) {
                    preRefreshCallback(newTaxonomy);
                }

                // Refresh the taxonomy list
                await this.getAllTaxonomy();
            } finally {
                SystemActions.endAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            }
        }
    },
    async editTaxonomy(taxonomy: ILibraryTaxonomyDetail, preRefreshCallback?: (updatedTaxonomy: ILibraryTaxonomyDetail) => void) {
        if (!SystemStore.isActionInProgress(TaxonomyConstants.TAXONOMY_UPDATE_EDIT)) {
            SystemActions.beginAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            try {
                const newTaxonomy = await TaxonomyServices.update(taxonomy);
                taxonomy.VersionToken = newTaxonomy.VersionToken;
                this.updateTaxonomyDetail(taxonomy)
                this._finishEdit(false);

                //update 
                this.getAllTaxonomy();
            } finally {
                SystemActions.endAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            }
        }
    },
    _finishEdit(close: boolean) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: TaxonomyConstants.TAXONOMY_FINISH_EDIT,
            modalVisible: !close
        });
    },
    async updateClassificationTagNew(updatedTaxonomy: ILibraryTaxonomyDetail) {
        if (!SystemStore.isActionInProgress(TaxonomyConstants.TAXONOMY_UPDATE_EDIT)) {
            SystemActions.beginAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            try {
                const newTaxonomy = await TaxonomyServices.update(updatedTaxonomy);
                updatedTaxonomy.VersionToken = newTaxonomy.VersionToken;
                this.updateTaxonomyDetail(updatedTaxonomy)
                this._finishEdit(false);
                await this.getAllTaxonomy();
            } finally {
                SystemActions.endAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            }
        }
    },
    async updateClassificationTag(type: TaxonomyType) {
        if (!SystemStore.isActionInProgress(TaxonomyConstants.TAXONOMY_UPDATE_EDIT)) {
            SystemActions.beginAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            try {
                let data = FacilityStore.getTaxonomyClassificationDetail(type);
                const newTaxonomy = await TaxonomyServices.update(data);
                data.VersionToken = newTaxonomy.VersionToken;
                this.updateTaxonomyDetail(data)
                this._finishEdit(false);
                await this.getAllTaxonomy();
            } finally {
                SystemActions.endAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            }
        }
    },
    async persistTaxonomyClassificationDetail(data: ILibraryTaxonomyDetail) {
        if (!SystemStore.isActionInProgress(TaxonomyConstants.TAXONOMY_UPDATE_EDIT)) {
            SystemActions.beginAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            try {
                const persistedTaxonomy = await TaxonomyServices.update(data);
                data.VersionToken = persistedTaxonomy.VersionToken;
                this.updateTaxonomyDetail(data);
                this._finishEdit(false);
                await this.getAllTaxonomy();
                return data;
            } finally {
                SystemActions.endAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            }
        }

        return data;
    },
    editTaxonomyProperty(comp: string, key: string, value: any): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: TaxonomyConstants.TAXONOMY_UPDATE_EDIT,
            component: comp,
            key: key,
            value: value
        });
    },
    toggleTaxonomy(isVisible: boolean): void {
        TaxonomyActions._dispatchAction(TaxonomyConstants.TOGGLE_TAXONOMY_MODAL, { isVisible })
    },
    finishTaxonomyEdit(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: TaxonomyConstants.TAXONOMY_BEGIN_FINISH,
        });
    },
    async deleteTaxonomy(taxonomy: ITaxonomy) {
        if (!SystemStore.isActionInProgress(TaxonomyConstants.TAXONOMY_UPDATE_EDIT)) {
            SystemActions.beginAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            try {
                await TaxonomyServices.deleteTaxonomy(taxonomy);
                this._finishEdit(false);
                const allTaxonomy = await this.getAllTaxonomy();
                if (allTaxonomy.length > 0) {
                    await TaxonomyActions.getTaxonomyDetail(allTaxonomy[0].ID);
                }
            } finally {
                SystemActions.endAction(TaxonomyConstants.TAXONOMY_UPDATE_EDIT);
            }
        }
    },
    _dispatchAction(actionType: string, data?: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: actionType,
            data: data
        });
    }
    
}

export default TaxonomyActions;
